import { apiHandler } from './api'
export * from './api'
export const ayeApi = apiHandler()
